import React, { Component } from "react";
import { Breadcrumb, DatePicker, Button, message, Input } from "antd";
import moment from "moment";
import { ACTION_STATUS } from "../../../../../utils/ActionStatus";
import "./MeetingAndTrainingDashboard.css";
import MeetingAndTrainingGrid from "./MeetingAndTrainingGrid";
import AddOrEditMeetingAndTrainingModalDialog from "./AddOrEditMeetingAndTrainingModalDialog";
import DelMeetingAndTrainingModalDialog from "./DelMeetingAndTrainingModalDialog";
import CopMeetingAndTrainingModalDialog from "./CopMeetingAndTrainingModalDialog";
import OperationRecordDialog from "../../../common/operationRcd/components/OperationRecordDialog";

class MeetingAndTrainingDashboard extends Component {
  buildLoadParams = () => {
    const {
      title,
      functiontype,
      fundandcompany,
      userName,
      year,
      startTime,
      endTime,
    } = this.props.meetingAndTrainingQueryFields;
    const queryYear = !!year ? (moment.isMoment(year) ? year.year() : year) : undefined;

    return {
      title,
      functiontype,
      fundandcompany,
      userName,
      year: queryYear,
      starttime: !!startTime ? startTime.format("YYYY-MM-DD") : null,
      endtime: !!endTime ? endTime.format("YYYY-MM-DD") : null,
    };
  };

  componentDidMount() {
    this.props.loadMeetingAndTrainingInfo(this.buildLoadParams());
    this.props.loadMeetingAndTrainingGroupInfo({ ismerge: "1" });
    this.props.loadInstituteUserAccounts({});
  }

  componentDidUpdate() {
    const {
      // query
      loadMeetingAndTrainingInfoActionStatus,
      loadMeetingAndTrainingInfoResp,
    } = this.props;

    if (loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadMeetingAndTrainingInfoActionStatus();
    }
    if (loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.ERROR) {
      let err = "Load User Access Info failed";
      if (
        !!loadMeetingAndTrainingInfoResp &&
        !!loadMeetingAndTrainingInfoResp.respMessage
      ) {
        err = loadMeetingAndTrainingInfoResp.respMessage;
      }
      message.error(err);
      this.props.initLoadMeetingAndTrainingInfoActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    if (name === "startTime" || name === "endTime" || name === "year") {
      if (!value) {
        value = null;
      } else if (!moment.isMoment(value)) {
        value = name === "year" ? moment(value, "YYYY", true) : moment(value, "YYYY-MM-DD", true);
      }
    }
    this.props.onQueryInputChange({ name, value });
  };

  isSelectedParentTrainingRow = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    return (
      selectedMeetingAndTrainingInfoArray.length === 1 &&
      Array.isArray(selectedMeetingAndTrainingInfoArray[0].detialList)
    );
  };

  isSelectedDetailTrainingRow = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    return (
      selectedMeetingAndTrainingInfoArray.length === 1 &&
      !Array.isArray(selectedMeetingAndTrainingInfoArray[0].detialList)
    );
  };

  addOrEditBtnOnClicked = (mode) => {
    if (mode === "ADD") {
      this.props.openAddOrEditMeetingAndTrainingModal(mode, null);
    } else {
      const { selectedMeetingAndTrainingInfoArray } = this.props;
      if (mode === "EDIT" && !this.isSelectedParentTrainingRow()) {
        message.warning("Please choose one parent training row");
        return;
      }
      if (mode === "EDITALL" && !this.isSelectedDetailTrainingRow()) {
        message.warning("Please choose one detailed training row");
        return;
      }
      if (selectedMeetingAndTrainingInfoArray.length !== 1) {
        message.warning("Please choose one and only one training session");
        return;
      }
      const currentMeetingAndTrainingInfo =
        selectedMeetingAndTrainingInfoArray[0];
      this.props.openAddOrEditMeetingAndTrainingModal(
        mode,
        currentMeetingAndTrainingInfo
      );
    }
  };

  copyAllBtnOnClicked = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    if (selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please choose one and only one training session");
      return;
    }
    const currentMeetingAndTrainingInfo = selectedMeetingAndTrainingInfoArray[0];
    this.props.openCopMeetingAndTrainingModal(currentMeetingAndTrainingInfo);
  };

  delBtnOnClicked = (mode) => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    if (selectedMeetingAndTrainingInfoArray.length === 0) {
      message.warning("Please choose at least one training session");
      return;
    }
    if (mode !== "del" && selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please choose one and only one training session");
      return;
    }
    const currentMeetingAndTrainingInfo =
      selectedMeetingAndTrainingInfoArray[0];
    const idList =
      mode === "del"
        ? selectedMeetingAndTrainingInfoArray.map((e) => e.id).join(",")
        : undefined;
    this.props.openDelMeetingAndTrainingModal(
      currentMeetingAndTrainingInfo,
      mode,
      idList
    );
  };

  refreshBtnOnClicked = () => {
    this.props.loadMeetingAndTrainingInfo(this.buildLoadParams());
  };

  selAnswereeButtonOnClicked = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;

    if (selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    this.props.loadUserAccounts(); // 每次打开页面需要先刷新userAccount
    this.props.openAnswereeSelectModalDialog();
  };

  // 操作记录页面，自定义需要展示的列
  opRcdCustomColumns = [
    "operator",
    "operateTime",
    "dataId",
    "operateType",
    "comments",
    "before",
    "after",
  ];

  render() {
    const {
      meetingAndTrainingQueryFields,
      loadMeetingAndTrainingInfoActionStatus,
    } = this.props;

    const { title, year, startTime, endTime } = meetingAndTrainingQueryFields;

    const refreshBtnIsLoading =
      loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.LOGINING;
    const editTrainingDisabled = !this.isSelectedParentTrainingRow();
    const editTrainingSeriesDisabled = !this.isSelectedDetailTrainingRow();
    const sessionActionsDisabled = this.isSelectedParentTrainingRow();

    return (
      <div className="MeetingAndTrainingWrapper">
        <div className="breadcrumbWrapper">
          <Breadcrumb>
            <Breadcrumb.Item></Breadcrumb.Item>
            <Breadcrumb.Item>Training</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="OperationBar">
          <div className="breadcrumbWrapper">
            <Breadcrumb>
              <Breadcrumb.Item> Search by:</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Input
            allowClear={true}
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder="Title"
            value={title}
            onPressEnter={this.refreshBtnOnClicked}
            onChange={(event) => {
              this.onInputChange({ name: "title", value: event.target.value });
            }}
          />
          <DatePicker
            allowClear={true}
            mode="year"
            format="YYYY"
            size="small"
            style={{ width: 120, marginLeft: 10 }}
            placeholder="Year"
            value={year}
            onChange={(yearValue) => {
              this.onInputChange({ name: "year", value: yearValue });
            }}
            onPanelChange={(yearValue) => {
              this.onInputChange({ name: "year", value: yearValue });
            }}
          />
          <DatePicker
            allowClear={true}
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder="Start Date"
            value={startTime}
            onChange={(startTime) => {
              this.onInputChange({ name: "startTime", value: startTime });
            }}
          />
          <DatePicker
            allowClear={true}
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder="End Date"
            value={endTime}
            onChange={(endTime) => {
              this.onInputChange({ name: "endTime", value: endTime });
            }}
          />
          {/* <Input 
                        placeholder="Function"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'functiontype', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="Fund/Co."
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'fundandcompany', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="User"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'userName', value: event.target.value })
                        }} 
                    /> */}
          {/* <Select
                        allowClear
                        showSearch
                        size='small'
                        // --value={!user ? undefined : user}
                        style={{marginLeft: 10, width: 150}}
                        //onChange={(value) => this.onInputChange({name: 'userName', value: value})}
                        onChange={(val) => {
                            this.onInputChange({ name: 'userName', value: val })
                        }} 
                        placeholder="Employee">
                        {meetingAndTrainingOptions}
                    </Select> */}
          {/* <Select
                        allowClear
                        size='small'
                        style={{ width: 150, marginLeft: 10 }}
                        onChange={(val) => {
                            this.onInputChange({ name: 'status', value: val })
                        }} 
                        placeholder="Status">
                        {statusOptions}
                    </Select> */}
          {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date Start"
                      onChange={(invDateStart, dateString) => {
                        this.onInputChange({ name: 'invDateStart', value: dateString });
                      }}
                    /> */}
          {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date End"
                      onChange={(invDateEnd, dateString) => {
                        this.onInputChange({ name: 'invDateEnd', value: dateString });
                      }}
                    /> */}
          <Button
            onClick={this.refreshBtnOnClicked}
            loading={refreshBtnIsLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />
          <Button
            onClick={() => this.addOrEditBtnOnClicked("ADD")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Add
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked("COPY")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Copy
          </Button>
          {/* <Button 
                        onClick={()=>this.copyAllBtnOnClicked()} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        Copy All
                    </Button> */}
          <Button
            onClick={() => this.addOrEditBtnOnClicked("EDIT")}
            disabled={editTrainingDisabled}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            type="primary"
          >
            Edit Training
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked("EDITALL")}
            disabled={editTrainingSeriesDisabled}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            type="primary"
          >
            Edit Training Series
          </Button>
          {/* <Button 
                        onClick={()=>this.delBtnOnClicked('inactive')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Inactivate User
                    </Button> */}
          <Button
            onClick={() => this.delBtnOnClicked("del")}
            disabled={sessionActionsDisabled}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="negative-button"
          >
            Del
          </Button>
          {/* <Button 
                        onClick={this.selAnswereeButtonOnClicked} 
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'>
                        Select Answeree
                    </Button> */}
          <Button
            onClick={() => this.delBtnOnClicked("send")}
            disabled={sessionActionsDisabled}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Send Email
          </Button>

          <Button
            onClick={() => this.delBtnOnClicked("Append")}
            disabled={sessionActionsDisabled}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Append user
          </Button>
          <Button
            onClick={() => this.delBtnOnClicked("postponed")}
            disabled={sessionActionsDisabled}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Postpone
          </Button>
          {/* <Button 
                        onClick={()=>this.props.doOperationRecordAction({action:'OPEN_AND_QUERY', queryFields: {module: 'MeetingAndTraining'}, customColumns: this.opRcdCustomColumns})} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Operation Record
                    </Button>  */}
        </div>

        <div className="MeetingAndTrainingGrid">
          <MeetingAndTrainingGrid {...this.props} />
        </div>
        <AddOrEditMeetingAndTrainingModalDialog
          {...this.props}
          buildLoadParams={this.buildLoadParams}
        />
        <DelMeetingAndTrainingModalDialog
          {...this.props}
          buildLoadParams={this.buildLoadParams}
        />
        <CopMeetingAndTrainingModalDialog
          {...this.props}
          buildLoadParams={this.buildLoadParams}
        />
        <OperationRecordDialog {...this.props} />
      </div>
    );
  }
}

export default MeetingAndTrainingDashboard;
